
import { defineComponent } from "vue";
import Header from "./components/Header.vue";
import loader from "./components/loader.vue";
import rateCard from "./components/rateCard.vue";
import exchangeField from "./components/exchangeField.vue";
import cardModal from "./components/cardModal.vue";
import { mapActions, mapState } from "vuex";

export default defineComponent({
  name: "App",
  data() {
    return {
      refreshDisabled: false,
      disabledDuration: 5,
      addCardName: "",
      openModal: false,
      choosenRatesData: [] as Array<any>,
      choosenRatesFromStorage: [] as Array<any>,
      choosenRates: ["USD", "EUR", "UAH", "BTC", "ETH"],
      interestedCurrencyList: ["USD", "EUR", "UAH"],
      interestedCurrency: "USD",
      originalCurrencyInput: 1,
      desiredCurrencyInput: 0,
      originalCurrency: "USD",
      desiredCurrency: "BTC",
      currencyList: ["USD", "EUR", "UAH", "GBP", "BTC", "ETH", "BNB", "XRP"],
      currentRate: 0,
      isBigValue: false,
      maximumValue: 10000,
      ratesForUSD: [] as Array<any>,
    };
  },
  methods: {
    ...mapActions(["getCurrencyData", "getAllRates"]),
    switchCurrency() {
      let temporaryValue = this.originalCurrency;
      this.originalCurrency = this.desiredCurrency;
      this.desiredCurrency = temporaryValue;
      this.getDataOnChange();
    },
    async getDataOnChange() {
      let dateNow = new Date().toISOString();
      await this.getCurrencyData([
        this.originalCurrency,
        this.desiredCurrency,
        dateNow,
      ]);
      this.currentRate =
        this.data.rate.toString().length > 7
          ? this.data.rate.toFixed(7)
          : this.data.rate;
      this.desiredCurrencyInput = this.currentRate * this.originalCurrencyInput;
    },
    async getAllDataToShow() {
      await this.getAllRates([this.interestedCurrency, false]);

      if (
        JSON.parse(localStorage.getItem("choosenRates") || "[]").length == 0
      ) {
        localStorage.setItem("choosenRates", JSON.stringify(this.choosenRates));
        localStorage.setItem("ratesForUSD", JSON.stringify(this.rates));
        this.choosenRatesData = this.getChoosenRates(this.choosenRates);
        this.choosenRatesFromStorage = JSON.parse(
          localStorage.getItem("choosenRates") || "[]"
        );
        //console.log("set this.choosenRatesData", this.choosenRatesData);
      } else {
        this.choosenRatesFromStorage = JSON.parse(
          localStorage.getItem("choosenRates") || "[]"
        );
        this.choosenRatesData = this.getChoosenRates(
          this.choosenRatesFromStorage
        );
        //console.log("else this.choosenRatesData", this.choosenRatesData);
      }
    },
    getChoosenRates(arr: Array<string>) {
      return arr
        .map((i: string) => {
          return this.rates.find((item: any) => {
            return item.asset_id_quote == i;
          });
        })
        .filter((i: string | undefined) => i !== undefined);
    },
    cardFormHandler() {
      if (this.addCardName) {
        this.choosenRatesFromStorage.push(this.addCardName);
        localStorage.setItem(
          "choosenRates",
          JSON.stringify(this.choosenRatesFromStorage)
        );
      }
      this.choosenRatesFromStorage = JSON.parse(
        localStorage.getItem("choosenRates") || "[]"
      );

      this.getAllDataToShow();

      this.addCardName = "";
      this.openModal = false;
    },
    countDownTimer() {
      if (this.disabledDuration > 0) {
        setTimeout(() => {
          this.disabledDuration -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    refreshData() {
      this.getAllDataToShow();
      this.refreshDisabled = true;
      this.disabledDuration = 5;
      this.countDownTimer();
      setTimeout(() => {
        this.refreshDisabled = false;
      }, this.disabledDuration * 1000);
    },
  },
  watch: {
    originalCurrency() {
      this.getDataOnChange();
    },
    desiredCurrency() {
      this.getDataOnChange();
    },
    interestedCurrency() {
      this.getAllDataToShow();
    },
    originalCurrencyInput(newState) {
      if (newState < 0 || newState == "") {
        this.originalCurrencyInput = 1;
      }

      newState > this.maxValue
        ? (this.isBigValue = true)
        : (this.isBigValue = false);
      this.desiredCurrencyInput = newState * this.currentRate;
    },
  },
  async mounted() {
    await this.getDataOnChange();
    await this.getAllDataToShow();
  },
  computed: {
    ...mapState(["data", "rates"]),
    maxValue(): number {
      let val = 0;
      if (this.originalCurrency !== "USD") {
        const ratesData = JSON.parse(
          localStorage.getItem("ratesForUSD") || "[]"
        );
        val = ratesData.filter(
          (i: any) => i.asset_id_quote == this.originalCurrency
        )[0].rate;
      } else {
        val = 1;
      }
      return val * this.maximumValue;
    },
  },
  components: {
    Header,
    exchangeField,
    loader,
    rateCard,
    cardModal,
  },
});
